import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            refetchOnWindowFocus: false,
        },
    },
});

// The stale-asset safety net in public/index.html reloads with a `_r` cache
// buster. We got here, so it worked — tidy the address bar and clear the guard
// so a future stale document can recover too.
(function cleanUpRecoveryMarker() {
    try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has("_r")) return;
        url.searchParams.delete("_r");
        window.history.replaceState({}, "", url.pathname + url.search + url.hash);
        sessionStorage.removeItem("procaresg:reloaded-for-stale-assets");
    } catch {
        /* history or storage unavailable — cosmetic only */
    }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>,
);
